export default "__VITE_ASSET__Coxkpdi7__"